import React from "react";
import { FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { InfoIcon } from "lucide-react";

interface SimplifiedTextFieldProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  description?: string;
  required?: boolean;
  videoUrl?: string;
  placeholder?: string;
  type?: "text" | "email" | "number" | "tel";
}

export const SimplifiedTextField: React.FC<SimplifiedTextFieldProps> = ({
  value = "",
  onChange,
  label,
  description,
  required = false,
  videoUrl,
  placeholder = "Digite aqui...",
  type = "text"
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <FormItem className="w-full">
      <div className="flex items-center mb-2">
        <label className="text-slate-500 font-bold px-2">
          {label}{required && <span className="text-red-500">*</span>}
        </label>
        
        {description && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <InfoIcon size={16} className="text-grey-light ml-1" />
              </TooltipTrigger>
              <TooltipContent>
                <p>{description}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>

      <Input
        type={type}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full"
      />
    </FormItem>
  );
}; 